const Content = {
  siteName: "Space Type",
  siteDescription:
    "Space Type is an independent type foundry, design studio, and riso micropress. Typefaces, prints, zines, apparel, and home goods produced with love and care.",
  siteUrl: "https://www.shop.spacetypeco.com",
};

export default Content;
